import { gql } from "@apollo/client";

export const VALIDATE_JOB_SETTINGS = gql`
	mutation validate ($input: ValidateJobSettingsInput!) {
		validateJobSettings(input: $input) {
			validateJobSettings {
				success, validationResult
			}
			errors {
				... on ArgumentError {
					message
				}
				... on JsonError {
					message
				}
			}

		}
	}
`;
